import { axiosInstance } from "@/api/axios";
import { AxiosRequestConfig } from "axios";

export type CreateExpenseSupplierFormValues = {
  name: string;
  contact_person?: string;
  email?: string;
  phone?: string;
  address?: string;
};

export type UpdateExpenseSupplierFormValues = {
  id: string;
  is_reviewed?: boolean;
} & CreateExpenseSupplierFormValues;

export const getExpenseSuppliers = async (config?: AxiosRequestConfig) => {
  const params = config?.params;

  if (params?.sort) {
    params.sort = JSON.stringify(params.sort);
  }

  if (params?.filters) {
    params.filters = JSON.stringify(params.filters);
  }
  const response = await axiosInstance.get("/suppliers", config);
  return response.data;
};

export const createExpenseSupplier = async (
  data: CreateExpenseSupplierFormValues
) => {
  const response = await axiosInstance.post("/suppliers", data);
  return response.data;
};

export const updateExpenseSupplier = async (
  id: string,
  data: UpdateExpenseSupplierFormValues
) => {
  const response = await axiosInstance.put(`/suppliers/${id}`, data);
  return response.data;
};

export const deleteExpenseSupplier = async (id: string) => {
  const response = await axiosInstance.delete(`/suppliers/${id}`);
  return response.data;
};

export const restoreExpenseSupplier = async (id: string) => {
  const response = await axiosInstance.post(`/suppliers/${id}/reactivate`);
  return response.data;
};
